import { Get } from '../../api/axiosCoreConfig';
import { createQueryParamsFromObject } from '../../api/helper';

export const getPatientStatistics = (namespace, params) =>
    Get(`/patient/statistics?namespace=${namespace}`, {
        params: createQueryParamsFromObject(params)
    });

export const getFormStatistics = (namespace, params) =>
    Get(`/form/f/statistics?namespace=${namespace}`, {
        params: createQueryParamsFromObject(params)
    });
